import { useQuery } from "@tanstack/react-query";
import { validateInvite } from "../../auth";

export const useValidateInvite = ( expires, user, signature) => {
  const query = useQuery({
    queryKey: ["validateInvite"],
    queryFn: () => validateInvite( expires, user, signature),
    refetchInterval: false,
  });
  return {
    isValidating: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    error: query.error,
  };
};
